import { useCallback } from 'react';
import { type OnTablePagination } from '@optimization/ssi-common';
import { type UpdateQueryParameterValues } from '../../hooks/use-update-query-parameter-values';
import useSetPaginationAndRowsPerPage from './use-set-pagination-and-rows-per-page';

interface UseOnPaginationProperties {
  rowsPerPage: number;
  updateQueryParameterValues: UpdateQueryParameterValues;
}

const useOnPagination = ({ rowsPerPage, updateQueryParameterValues }: UseOnPaginationProperties): OnTablePagination => {
  const setPaginationValueAndRowsPerPage = useSetPaginationAndRowsPerPage({ rowsPerPage, updateQueryParameterValues });

  return useCallback(
    ({ paginationValue, rowsPerPage }) => {
      setPaginationValueAndRowsPerPage({ paginationValue, rowsPerPage });
    },
    [setPaginationValueAndRowsPerPage],
  );
};

export default useOnPagination;
